import script from "./orderEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./orderEditModal.vue?vue&type=script&setup=true&lang=js"

import "./orderEditModal.vue?vue&type=style&index=0&id=61c82bc7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c82bc7"]])

export default __exports__